// Bông hoa 5 cánh thay sao — CEO chốt 20/08/2026 qua mockup: nút 56px, số
// 1–5 nằm giữa, mặc định XÁM hết, bấm mức n thì bông 1→n cùng lên màu mức n
// (1 đỏ → 5 xanh lá). Cánh = 5 hình tròn quanh nhuỵ.

const FLOWER_COLORS: Record<number, string> = {
  1: "#E24B4A",
  2: "#D85A30",
  3: "#EF9F27",
  4: "#97C459",
  5: "#639922",
};

export const SCORE_LABELS: Record<number, string> = {
  1: "Rất tệ",
  2: "Chưa hài lòng",
  3: "Bình thường",
  4: "Hài lòng",
  5: "Rất hài lòng",
};

const PETAL_IDLE = "#E7E5DC";
const CORE_IDLE = "#D3D1C7";
const NUM_IDLE = "#5F5E5A";

/** Toạ độ 5 cánh quanh tâm (50,50), bán kính đặt cánh 26, cánh r=23. */
const PETALS = [0, 1, 2, 3, 4].map((i) => {
  const angle = (-90 + i * 72) * (Math.PI / 180);
  return { cx: 50 + 26 * Math.cos(angle), cy: 50 + 26 * Math.sin(angle) };
});

function Flower({ value, active, color, onPick }: { value: number; active: boolean; color: string; onPick: () => void }) {
  return (
    <button
      type="button"
      onClick={onPick}
      aria-label={`${value} điểm — ${SCORE_LABELS[value]}`}
      aria-pressed={active}
      className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full transition-transform active:scale-90"
    >
      <svg viewBox="0 0 100 100" className="h-14 w-14" role="presentation">
        {PETALS.map((p, i) => (
          <circle key={i} cx={p.cx} cy={p.cy} r={23} fill={active ? color : PETAL_IDLE} />
        ))}
        <circle cx={50} cy={50} r={25} fill={active ? color : CORE_IDLE} />
        <circle cx={50} cy={50} r={21} fill={active ? "#FFFFFF" : "#F4F2EA"} opacity={active ? 0.22 : 1} />
        <text
          x={50}
          y={50}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={30}
          fontWeight={700}
          fill={active ? "#FFFFFF" : NUM_IDLE}
        >
          {value}
        </text>
      </svg>
    </button>
  );
}

/**
 * Hàng 5 bông cho MỘT người. score=0 nghĩa là chưa chấm (bỏ trống được).
 * Bấm lại đúng mức đang chọn → bỏ chấm (về 0), để khách "không nhớ thì thôi".
 */
export function FlowerRating({ score, onChange }: { score: number; onChange: (score: number) => void }) {
  const color = FLOWER_COLORS[score] ?? CORE_IDLE;
  // Hàng hoa rộng 304px cố định (5×56 + 4 khoảng cách). Máy 375px còn 319px
  // nên vừa, nhưng máy hẹp hơn thì phải cuộn ngang — KHÔNG thu nhỏ bông:
  // 56px là kích thước CEO duyệt trên mockup và cũng là mức chạm tối thiểu.
  return (
    <div
      className="flex items-center gap-1.5 overflow-x-auto"
      role="radiogroup"
      aria-label="Chấm điểm 1 tới 5"
    >
      {[1, 2, 3, 4, 5].map((value) => (
        <Flower
          key={value}
          value={value}
          active={score >= value}
          color={color}
          onPick={() => onChange(value === score ? 0 : value)}
        />
      ))}
    </div>
  );
}
